import { fork, takeEvery, all } from 'redux-saga/effects';
import config from '../../../config/config';
import { LogControllerDtoNftRestoreLogListRequest, PerplayLogApi } from '../../models/src';
import { NFT_RESTORE_LOG_LIST_REQUEST } from '../../constants/log/nftRestoreLogConstants';
import { getErrorMessage } from '../../../utils/serverErrorCheck';
import LogControllerDtoNftRestoreLogListResponse
  from '../../models/src/model/LogControllerDtoNftRestoreLogListResponse';

const api = new PerplayLogApi(config.API_CLIENT);

function* nftRestoreLogListRequestSaga(payload) {
  console.assert(payload.callback, {
    message: 'callback이 설정되지 않았습니다.',
  });

  try {
    const requestData = new LogControllerDtoNftRestoreLogListRequest();
    requestData.page = payload.page;
    requestData.pageLength = payload.pageLength;
    requestData.beginDate = payload.beginDate;
    requestData.endDate = payload.endDate;
    requestData.account = payload.account;
    requestData.nftUid = payload.nftUid;
    requestData.transactionNo = payload.transactionNo;
    console.log('요청 데이터: ', requestData);

    const result = yield api.apiPerplayLogNftRestoreLogListPost({ logControllerDtoNftRestoreLogListRequest: requestData }, () => {});
    const data = api.apiClient.deserialize(result, LogControllerDtoNftRestoreLogListResponse);

    if (data.resultCode !== 200) {
      throw new Error(getErrorMessage(data));
    }
    payload.callback(data);
  } catch (e) {
    payload.error(e);
  }
}

function* nftRestoreLogRootSaga() {
  yield all([
    takeEvery(NFT_RESTORE_LOG_LIST_REQUEST, nftRestoreLogListRequestSaga),
  ]);
}

const nftRestoreLogSaga = [
  fork(nftRestoreLogRootSaga),
]

export default nftRestoreLogSaga;
